module.exports = __webpack_public_path__ + "img/Barbarian.eafd222d.png";